import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"outer":"styles_outer__leI8u","vertical":"styles_vertical__gw4w5","inner":"styles_inner__Ww4yg","horizontal":"styles_horizontal__eQGbB"};
export const b = b_.with('outer');